import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import QSelect from 'quasar/src/components/select/QSelect.js';;
import { appStore, jobApiStore } from "@/hooks";
import {
  DetailsPanel,
  ArtifactInput,
  ArtifactTypeInput,
  PanelCard,
  FlexBox,
  TextButton,
} from "@/components/common";
import { performHealthChecks } from "@/api/endpoints/health-api";
import { HealthTask } from "@/types/api/health-api";

// Component state

const __default__ = {
  name: "HealthPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifactTypes = ref<string[]>([]);
const artifactIds = ref<string[]>([]);
const selectedTasks = ref<HealthTask[]>([]);

const isButtonEnabled = computed(() => {
  return (
    selectedTasks.value.length > 0 &&
    (artifactTypes.value.length > 0 || artifactIds.value.length > 0)
  );
});

const taskOptions = ref<Array<{ label: string; value: HealthTask }>>([
  { label: "Contradiction", value: "contradiction" },
  { label: "Concept Matching", value: "concept_matching" },
  { label: "Concept Extraction", value: "concept_extraction" },
]);

// Clear state when the component goes into view
onMounted(() => {
  // Initialize or clear state here if needed
  artifactTypes.value = [];
  artifactIds.value = [];
});

// Optionally, you can clear the state before the component unmounts
onBeforeUnmount(() => {
  artifactTypes.value = [];
  artifactIds.value = [];
});

function handlePerformHealthChecks() {
  performHealthChecks(
    selectedTasks.value,
    artifactIds.value,
    artifactTypes.value
  );
  appStore.closeSidePanels();
  artifactTypes.value = [];
  artifactIds.value = [];
  selectedTasks.value = [];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), { panel: "health" }, {
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        borderless: "",
        title: "Generate Health Checks"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArtifactTypeInput), {
            modelValue: artifactTypes.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((artifactTypes).value = $event)),
            class: "q-mb-md",
            "data-cy": "input-document-include-types",
            label: "Include Artifact Types",
            multiple: "",
            onBlur: _ctx.handleSaveTypes
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_unref(ArtifactInput), {
            modelValue: artifactIds.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((artifactIds).value = $event)),
            class: "q-mb-md",
            "data-cy": "input-document-artifacts",
            label: "Artifacts",
            multiple: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(QSelect), {
            modelValue: selectedTasks.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTasks).value = $event)),
            options: taskOptions.value,
            "emit-value": "",
            label: "Select Health Tasks",
            "map-options": "",
            multiple: ""
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_unref(FlexBox), {
            "full-width": "",
            justify: "end",
            t: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), {
                disabled: !isButtonEnabled.value,
                color: "primary",
                label: "Perform Health Checks",
                onClick: handlePerformHealthChecks
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})